var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24Snapchat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-snapchat",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7360",
    "data-name": "Rectangle 7360",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11017",
    "data-name": "Path 11017",
    d: "M9,0A9,9,0,1,1,0,9,9,9,0,0,1,9,0Zm3.914,13.432a.146.146,0,0,0,.156-.117c.027-.092.047-.179.066-.267.053-.243.088-.36.177-.373,1.09-.169,1.4-.4,1.471-.56a.206.206,0,0,0,.017-.07.123.123,0,0,0-.1-.128,3.611,3.611,0,0,1-2.458-2.061l0-.006a.638.638,0,0,1-.06-.536c.115-.271.49-.39.738-.469.061-.019.119-.038.164-.055.435-.172.523-.346.521-.462a.37.37,0,0,0-.281-.3h0a.535.535,0,0,0-.2-.038.424.424,0,0,0-.175.034,1.5,1.5,0,0,1-.563.156h0a.477.477,0,0,1-.325-.113c.006-.1.012-.21.019-.32l0-.034a5.866,5.866,0,0,0-.139-2.339,3.037,3.037,0,0,0-2.82-1.816H9.087l-.206,0A3.031,3.031,0,0,0,6.066,5.373a5.864,5.864,0,0,0-.139,2.339c.008.122.015.241.021.354a.492.492,0,0,1-.357.114,1.443,1.443,0,0,1-.6-.157.319.319,0,0,0-.136-.027.468.468,0,0,0-.455.3c-.019.1.022.3.517.5.045.018.1.036.164.055.248.079.623.2.738.469a.638.638,0,0,1-.06.536l0,.006A3.613,3.613,0,0,1,3.3,11.918a.123.123,0,0,0-.1.128.208.208,0,0,0,.017.07c.07.163.382.393,1.472.561.094.014.128.152.177.375.019.087.039.176.066.269a.154.154,0,0,0,.17.121,1.436,1.436,0,0,0,.244-.035A3.232,3.232,0,0,1,6,13.332a2.907,2.907,0,0,1,.473.04,2.269,2.269,0,0,1,.9.459,2.538,2.538,0,0,0,1.555.613l.058,0h0l.089,0a2.539,2.539,0,0,0,1.556-.614,2.265,2.265,0,0,1,.9-.459,2.909,2.909,0,0,1,.473-.04,3.256,3.256,0,0,1,.655.069,1.366,1.366,0,0,0,.244.031h.014Z",
    transform: "translate(3 3)",
    fill: "#adb5b9",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24Snapchat);
export default __webpack_public_path__ + "static/media/icon-24-snapchat.d3091448a783f87a8cf2d0ea2a383e80.svg";
export { ForwardRef as ReactComponent };